var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "confirm",
        {
          attrs: {
            showMask: true,
            title: _vm.confirmText.title,
            closeIcon: true,
            close: _vm.close,
            leftBtnClick: _vm.submit,
            leftBtnTxt: _vm.confirmText.submit,
            singleBtn: true,
            btnUnuse: !_vm.canSubmit
          }
        },
        [
          _c("div", { staticClass: "__row" }, [
            _c("div", { staticClass: "__row_t" }, [
              _vm._v(_vm._s(_vm.confirmText.available))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__input_row __unuse_input __bold" }, [
              _c("img", {
                staticClass: "__icon",
                attrs: { src: _vm.vxTokenInfo.icon }
              }),
              _vm._v("dSLS\n            "),
              _c("span", { staticClass: "__right" }, [
                _vm._v(_vm._s(_vm.basicAvailableAmount))
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "__row" },
            [
              _c("div", { staticClass: "__row_t" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.confirmText.amountText) +
                    "\n            "
                ),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.amountErr,
                        expression: "amountErr"
                      }
                    ],
                    staticClass: "__err"
                  },
                  [_vm._v(_vm._s(_vm.amountErr))]
                )
              ]),
              _vm._v(" "),
              _c(
                "vite-input",
                {
                  attrs: {
                    valid: _vm.validAmount,
                    placeholder: _vm.confirmText.amountPlaceholder
                  },
                  on: { input: _vm.noAll },
                  model: {
                    value: _vm.amount,
                    callback: function($$v) {
                      _vm.amount = $$v
                    },
                    expression: "amount"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "all-wrapper",
                      attrs: { slot: "after" },
                      on: { click: _vm.all },
                      slot: "after"
                    },
                    [
                      _c("span", { staticClass: "all" }, [
                        _vm._v(_vm._s(_vm.$t("tradeAssets.all")))
                      ])
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isLockVX
            ? _c("div", [
                _c("div", { staticClass: "__hint distance" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("tradeDividend.addHint1")))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "__hint" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("tradeDividend.addHint2")))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "__hint" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("tradeDividend.addHint3")))])
                ])
              ])
            : _c("div", [
                _c("div", { staticClass: "__hint distance" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("tradeDividend.unlockVXConfirm.hint")))
                  ])
                ])
              ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }